import React from "react";
function Loading() {
  return (
    <div
      data-testid="loading"
      style={{
        width: "100%",
        height: "100%",
        display: "grid",
        placeContent: "center",
        backgroundImage: "linear-gradient(rgba(0,0,0,0.2),rgba(0,0,0,0.2))",
        color: "white",
      }}
    >
      Fetching...
    </div>
  );
}

export default Loading;
